// Copyright (c) Docugami, Inc. All rights reserved.

import { DocHeaderButtonProps, DocumentHeaderButton } from "components/doc_hosting/presentation/DocumentHeaderButton";

export enum ToolType {
    SelectionMode,
    HighlighterMode,
    Parent,
    Child,
    Previous,
    Next,
    Link,
    RepeatsEditor,
    TextEdit
}

export interface ToolbarItemProps extends DocHeaderButtonProps {
    id: ToolType;
}

export const ToolbarItem = (props: ToolbarItemProps): JSX.Element => {
    const toolNames = getToolTypeFriendlyName(props.id);
    return <DocumentHeaderButton {...props} label={toolNames.longName ?? toolNames.friendlyName} />;
}

interface ToolNames {
    friendlyName: string,
    longName?: string
}

export function getToolTypeFriendlyName(id: ToolType): ToolNames {
    switch (id) {
        case ToolType.SelectionMode:
            return { friendlyName: 'Select', longName: 'Select' };
        case ToolType.HighlighterMode:
            return { friendlyName: 'Highlight', longName: 'Highlight' };
        case ToolType.Parent:
            return { friendlyName: 'Grow', longName: 'Grow Selection' };
        case ToolType.Child:
            return { friendlyName: 'Shrink', longName: 'Shrink Selection' };
        case ToolType.Previous:
            return { friendlyName: 'Prev', longName: 'Previous Chunk' };
        case ToolType.Next:
            return { friendlyName: 'Next', longName: 'Next Chunk' };
        case ToolType.Link:
            return { friendlyName: 'Link', longName: 'Link' };
        case ToolType.RepeatsEditor:
            return { friendlyName: 'Repeats', longName: 'Repeats Editor' };
        case ToolType.TextEdit:
            return { friendlyName: 'Edit', longName: 'Edit Selected Text' };
    }
}
